module.exports = __webpack_public_path__ + "img/chess-king.d7021c3e.svg";